module.exports = __webpack_public_path__ + "img/icon-5-bg.90be7d77.png";